<ideal-navigation-menu-bar main [items]="navStore.topItems()" orientation="vertical" />
<ideal-navigation-menu-bar [items]="navStore.bottomItems()" orientation="vertical" />
<ideal-version-info />
